<template>
    <v-card color="success" class="body-2 pa-3 white--text" v-if="showConfirmationEmailInfo">

        <div class="pl-2">

            {{ confirmationInfoHeader }}

            <div class="pt-3"></div>

            <ul>
                <li>
                    {{ subPanelTranslations.confirmation_email_spam_info }}
                </li>
                <li>
                    {{ addressBookInfo }}
                </li>
            </ul>
        </div>
    </v-card>
</template>

<script>

import TextEditor from "@/components/UI/TextEditor.vue";

export default {

    name: "ConfirmationEmailInfoBox",

    components: {TextEditor},

    props: {
        type: {
            type: String,
            required: true,
        },
        subPanelTranslations: {
            type: Object,
            required: true,
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false,
        },
        emailFromAddress: {
            type: String,
            required: true,
        }
    },

    computed: {

        showConfirmationEmailInfo() {
            return this.type === 'registration-complete';
        },

        confirmationResent() {
            let url = new URL(window.location.href);
            let registered = url.searchParams.get('confirmation_resent');
            return !!registered;
        },

        confirmationInfoHeader() {
            if (this.confirmationResent) {
                return this.subPanelTranslations.confirmation_email_not_confirmed_info;
            } else {
                return this.subPanelTranslations.confirmation_email_sent_info;
            }
        },

        addressBookInfo() {

            if (this.showConfirmationEmailInfo) {
                return this.subPanelTranslations.confirmation_email_address_book_info.replace('[email-address]', this.emailFromAddress);
            }
        },
    }
}
</script>